import { invalid } from "moment";

export const validationMessages = {
    email: {
        required : "Please provide email",
        invalid : "Please provide valid email",
    },
    phone: {
        required : "Please provide phone",
        invalid : "Please provide valid phone",
    },
    firstname: {
        required : "Please provide first name",
        invalid : "Please provide valid first name",
    },
    lastname: {
        required : "Please provide last name",
        invalid : "Please provide valid last name",
    },
     firstName: {
        required : "Please provide first name",
        invalid : "Please provide valid first name",
    },
    lastName: {
        required : "Please provide last name",
        invalid : "Please provide valid last name",
    },
    title: {
        required : "Please provide title", 
    },
    whatsapp_no: {
        required : "Please provide whatsapp number", 
        invalid : "Please provide valid whatsapp number", 
    },
    whatsappNumber: {
        required : "Please provide whatsapp number", 
        invalid : "Please provide valid whatsapp number", 
    },
    reference: {
        required : "Please provide reference name", 
        invalid : "Please provide valid reference name", 
    },
    city: {
        required : "Please provide city", 
        invalid : "Please provide valid city", 
    },
    pinCode: {
        required : "Please provide pinCode", 
        invalid : "Please provide valid pincode", 
    },
    country: {
        required : "Please provide country name", 
        invalid : "Please provide valid country name", 
    },
    password: {
        required : "Please provide password", 
        invalid : "Please provide valid password", 
    },
    userRole: {
        required : "Please provide userRole",
    },
    managerId: {
        required : "Please provide managerId",
    },
    leadtype:{
        required : "Please provide lead type",
    },
    lead_name:{
        required : "Please provide lead name",
        invalid : "Please provide valid lead name", 
    },
    lead_status:{
        required : "Please provide lead status",
        invalid : "Please provide valid lead status", 
    },
     leadType:{
        required : "Please provide lead type",
    },
    leadName:{
        required : "Please provide lead name",
        invalid : "Please provide valid lead name", 
    },
    leadStatus:{
        required : "Please provide lead status",
        invalid : "Please provide valid lead status", 
    },
    customerType:{
        required : "Please provide customer type",
    },
     tel:{
        required : "Please provide telephone number",
        invalid: "Please provide valid telephone number",
    },
    customer_type:{
        required : "Please provide customer type",
    },
    customer_primary_name:{
        required : "Please provide customer primary name",
        required : "Please provide valid customer primary name",
    },
    name:{
        required : "Please provide name",
        invalid : "Please provide valid name", 
    },
    gstNo:{
        required : "Please provide gst number",
        invalid : "Please provide valid gst number", 
    },
    quantity:{
        required : "Please provide gst number",
        invalid : "Please provide valid quantity number", 
    },
    ownerId:{
        required : "Please provide assign user",
    },
    ownerIds:{
        required : "Please provide assign user",
    },
    owner_id:{
        required : "Please provide assign user",
    },
    remarks:{
        required : "Please provide remark",
    },

    type:{
        required : "Please provide type", 
    },
    priority:{
        required : "Please provide priority", 
    },
    status:{
        required : "Please provide status", 
    },
    date:{
        required : "Please provide date", 
    },

    offerName:{
        required : "Please provide offer name",
        invalid: "Please provide valid offer name",
    },

    orderName:{
        required : "Please provide order",
        invalid: "Please provide valid order",
    },

    teliphone:{
        required : "Please provide telephone number",
        invalid: "Please provide valid telephone number",
    },

    handoverDate:{
        required : "Please provide handover date",
    },
     
    offerId:{
        required : "Please provide Offer",
    },
    orderId:{
        required : "Please provide Order",
    },
    warrantStartDate:{
        required : "Please provide start date",
    },
    warrantEndDate:{
        required : "Please provide end date",
    },

    folderName:{
        required : "Please provide folder name",
        invalid : "Please provide valid folder name",
    },
    file:{
        required : "Please provide a file",
    },
    // offer validation messages
    highestModelRate:{
        required : "Please provide offer rate",
        invalid : "Please provide valid offer rate",
    },
    numberOfUnits:{
        required : "Please provide number of units",
        invalid : "Please provide valid number of units",
    },
    input: {
        required : "Please provide input",
        invalid : "Please provide valid input",
    },
    // {/* Added By Farhan Khan on 17-Dec-2025 As Per Client Needs in AMC Ticket 1009 */}
    segment: {
        required : "Please provide Segment",
        invalid : "Please provide valid Segment",
    },
    area: {
        required : "Please provide area", 
        invalid : "Please provide valid area", 
    },
    // {/* End Here By Farhan Khan on 17-Dec-2025 As Per Client Needs in AMC Ticket 1009 */}
}